
import React, {FC} from 'react';
import {PartialLocation} from 'templates/booking/Content/LocationNotes';

import Item, {ItemProps} from './Item';

import * as styles from './styles.module.scss';

type ItemsProps = {
	location: PartialLocation
	isPrivate?: boolean
}

const renderStore = (isStore?: boolean): string => {
	if (isStore === undefined) {
		return '';
	}
	return isStore ? 'Store' : 'Mobile Clinic';
};

const renderWeight = (isStore?: boolean): string => {
	if (isStore === undefined) {
		return '';
	}
	return isStore ? '450 lbs' : '350 lbs';
};

const renderPrivate = (isPrivate?: boolean): string => {
	if (isPrivate === undefined) {
		return '';
	}
	return isPrivate ? 'Private' : 'Public';
};

const Items: FC<ItemsProps> = ({location, isPrivate}) => {
	const items: ItemProps[] = [{
		title: 'Type of location',
		text: renderStore(location.details.isStore),
	}, {
		title: 'Weight limit',
		text: renderWeight(location.details.isStore),
		hover: 'Weight limits are based on manufacturer recommendations to maintain image quality and scan accuracy.'
	}, {
		title: 'Type of event',
		text: renderPrivate(isPrivate),
		hover: 'Private locations may not be accessible to the general public.',
	}];

	return (
		<div className={styles.items}>
			<div className={styles.row}>
				{items.map((item, index) => (
					<React.Fragment key={index}>
						{index > 0 && <div className={styles.vertical} />}
						<Item {...item} />
					</React.Fragment>
				))}
			</div>
			<hr />
		</div>
	);
};

export default Items;
